import { authHeader, handleResponse, config } from '../../_helpers';

export const roleService = {
    login,
    logout,
    add,
    getAll,
    getById,
    update,
    delete: _delete,
    getCurrentrole,
    getAllRoleFilters,
    getModuleActionPermissions,
    isNameUnique
};

function login(rolename, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'mode': 'cors' },
        body: JSON.stringify({ 
            Email: rolename, 
            Password: password })
    };
    return fetch(`${config.apiUrl}/auth/login`, requestOptions)
        .then(handleResponse)
        .then(role => {
            // store role details and jwt token in local storage to keep role logged in between page refreshes
            localStorage.setItem('role', JSON.stringify(role));
            console.log("35: Inside roleService", role);
            return role;
        });
    //return role;
}

function logout() {
    // remove role from local storage to log role out
    localStorage.removeItem('role');
    localStorage.removeItem('tenant');
}

function getAll(paramsObj) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(paramsObj),
    };
    return fetch(`${config.apiUrl}/role/getroles`, requestOptions).then(handleResponse);
}
function getAllRoleFilters() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
        // body: tenantId
    };

    return fetch(`${config.apiUrl}/role/allrolefilters`, requestOptions).then(handleResponse);
}
function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/roles/${id}`, requestOptions).then(handleResponse);
}

function add(role) {
    const requestOptions = {
        method: 'POST',
        headers: {...authHeader(),'Content-Type': 'application/json' },
        body: JSON.stringify(role)
    };

    return fetch(`${config.apiUrl}/role/add`, requestOptions).then(handleResponse);
}

function update(role) {
    const requestOptions = {
        method: 'POST',
        headers: {...authHeader(),'Content-Type': 'application/json' },
        body: JSON.stringify(role)
    };

    return fetch(`${config.apiUrl}/role/update`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/roles/${id}`, requestOptions).then(handleResponse);
}
async function getCurrentrole() {
    let roleFromLocalStorage = JSON.parse(localStorage.getItem('role'));
    // const requestOptions = {
    //     method: 'GET',
    //     headers: authHeader()
    // };

    // return fetch(`${config.apiUrl}/roles/${roleFromLocalStorage.id}`, requestOptions).then(handleResponse);

    // return new Promise((resolve, reject) => {
    //     resolve(roleFromLocalStorage);
    // });
    return roleFromLocalStorage;
}
async function isNameUnique(requestObject) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(requestObject)
    };

    return fetch(
        `${config.apiUrl}/role/isunique`,
        requestOptions
    ).then(handleResponse);
}
async function getModuleActionPermissions(requestObject) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(requestObject)
    };

    return fetch(
        `${config.apiUrl}/role/GetModuleActionPermission`,
        requestOptions
    ).then(handleResponse);
}
function handleResponseBadly(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}